import { render, staticRenderFns } from "./BookingPayments.vue?vue&type=template&id=5dd08b15&scoped=true&lang=pug"
import script from "./BookingPayments.vue?vue&type=script&lang=js"
export * from "./BookingPayments.vue?vue&type=script&lang=js"
import style0 from "./BookingPayments.vue?vue&type=style&index=0&id=5dd08b15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd08b15",
  null
  
)

export default component.exports